<template>
  <div
    class="button-switch-component d-flex align-items-center"
    :class="{ 'normal-style': !radius, 'radius-style': radius }"
  >
    <button
      type="button"
      v-for="(item, index) in options"
      :name="`button-switch-${item.value}`"
      :key="index"
      class="btn btn-block m-0"
      :class="{
        'btn-outline-secondary': value !== item.value,
        'btn-primary': value === item.value,
        'slim-size': slim,
        'radius-style': radius
      }"
      @click="$emit('input', item.value)"
    >
      {{ item.title }}
    </button>
  </div>
</template>
<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => [{ title: "item 1" }, { title: "item 2" }]
    },
    value: {
      type: [Number, String, Object, Boolean],
      default: 0
    },
    slim: {
      type: Boolean,
      default: false
    },
    radius: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.button-switch-component {
  border: 1px solid #d2d0d8;
  border-radius: 4px;
  box-sizing: border-box;
  overflow: hidden;

  .btn-outline-secondary:hover {
    background: transparent;
    color: $secondary;
    text-decoration: none;
    outline: none;
    border: 0;
  }

  &.radius-style {
    border-radius: 24px;
  }

  button {
    border-width: 0;
    border-radius: 0;
  }

  .normal-style {
    &.btn-outline-secondary:not(:last-child):not(:first-child) {
      border-radius: 0px !important;
    }

    &.btn-outline-secondary:first-child {
      border-right-color: transparent;
    }

    &.btn-outline-secondary:last-child {
      border-left-color: transparent;
    }
  }

  .slim-size {
    min-height: 32px !important;
  }
  .btn,
  .btn-outline-primary,
  .btn-outline-secondary,
  .btn-primary,
  .btn-secondary {
    padding-left: 5px !important;
    padding-right: 5px !important;

    @media screen and (max-width: 1199px) {
      padding-left: 5px !important;
      padding-right: 5px !important;
      font-size: 12px;
    }
  }

  .radius-style {
    &.btn-outline-secondary:not(:last-child):not(:first-child) {
      border-radius: 0px !important;
    }

    &.btn-outline-secondary:first-child {
      border-radius: 24px 0px 0px 24px !important;
      border-right-color: transparent;
    }

    &.btn-outline-secondary:last-child {
      border-radius: 0px 24px 24px 0px !important;
      border-left-color: transparent;
    }

    &.btn-primary {
      border-radius: 24px;
    }

    &.btn-outline-secondary:not(:disabled):not(.disabled):active,
    &.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,
    &:focus-visible {
      color: $secondary;
      background-color: transparent;
      border-color: transparent;
      outline: none;
      box-shadow: none;
      border: 0;
    }
  }
}
</style>
